module.exports = __webpack_public_path__ + "static/media/gl.28a07cff.svg";